"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _classnames = _interopRequireDefault(require("classnames"));

var _colors = require("HubStyleTokens/colors");

var _UIDialogHeader = _interopRequireDefault(require("../dialog/UIDialogHeader"));

var _Functions = require("../core/Functions");

var _PanelNavigatorContext = require("../context/PanelNavigatorContext");

var _PanelComponentRegistrationContext = require("../context/PanelComponentRegistrationContext");

var LeftContentWrapper = _styledComponents.default.div.withConfig({
  displayName: "UIPanelHeader__LeftContentWrapper",
  componentId: "sc-14s8p37-0"
})(["position:relative;left:-12px;margin-right:28px;&::after{background-color:", ";content:'';height:32px;opacity:0.5;position:absolute;right:-21px;top:50%;transform:translateY(-50%);width:1px;}"], _colors.OLAF);

var UIPanelHeader = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UIPanelHeader, _Component);

  function UIPanelHeader() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UIPanelHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UIPanelHeader)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      currentPanel: null
    };
    return _this;
  }

  (0, _createClass2.default)(UIPanelHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var currentPanel = (0, _Functions.callIfPossible)(this.context.getCurrentPanel);

      if (currentPanel) {
        this.setState({
          currentPanel: currentPanel
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          leftContent = _this$props.leftContent,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "leftContent"]);
      var currentPanel = this.state.currentPanel;
      var computedLeftContent = leftContent || (0, _Functions.callIfPossible)(this.context.renderNavigation, currentPanel);
      var classes = (0, _classnames.default)(className, 'private-panel__header');
      return _react.default.createElement(_UIDialogHeader.default, Object.assign({}, rest, {
        className: classes
      }), _react.default.createElement(_PanelComponentRegistrationContext.RegistersPanelHeader, null), computedLeftContent && _react.default.createElement(LeftContentWrapper, null, computedLeftContent), children);
    }
  }]);
  return UIPanelHeader;
}(_react.Component);

exports.default = UIPanelHeader;
UIPanelHeader.propTypes = _UIDialogHeader.default.propTypes;
UIPanelHeader.defaultProps = _UIDialogHeader.default.defaultProps;
UIPanelHeader.contextType = _PanelNavigatorContext.PanelNavigatorContext;
UIPanelHeader.displayName = 'UIPanelHeader';
module.exports = exports.default;